<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeOrderStatus
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeOrderStatusProps } from '../types/interfaces'

import { useBadgeOrderStatus } from '../composables/use-badge-order-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeOrderStatus',
})

const props = defineProps<BadgeOrderStatusProps>()

const {
  color,
  text,
} = useBadgeOrderStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
